import { render, staticRenderFns } from "./TaskTabContent.vue?vue&type=template&id=04522022&scoped=true&"
import script from "./TaskTabContent.vue?vue&type=script&lang=js&"
export * from "./TaskTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04522022",
  null
  
)

export default component.exports